import { queries } from '../lib/supabase/queries';

export const servicesService = {
  async getAll() {
    return queries.services.getAll();
  },

  async getActive() {
    return queries.services.getActive();
  },

  async create(service) {
    return queries.services.create(service);
  },

  async update(id, updates) {
    return queries.services.update(id, updates);
  },

  async delete(id) {
    return queries.services.delete(id);
  },
};

export default servicesService;
